import { GridView } from '@mui/icons-material';
import type { CustomWidgetDescription } from 'components/management/customDashboard/CustomWidgetDescription.types.ts';
import PositionSummary from './PositionSummary.tsx';
import PositionSummaryLight from './PositionSummaryLight.tsx';
import { usePortfolioDashboardInputQuery } from 'generated/graphql.tsx';
import { UserSettings } from 'components/management/UserSettings.types.ts';
import { useDefaultErrorHandling } from 'components/technical/UseDefaultErrorHandling.tsx';
import Loader from 'components/technical/Loader/Loader.tsx';
import {
  PositionSummarySettings,
  type PositionSummarySettingsState,
} from 'components/portfolio/openPositions/PositionSummarySettings.tsx';
import {
  PositionSummaryLightSettings,
  type PositionSummaryLightSettingsState,
} from 'components/portfolio/openPositions/PositionSummaryLightSettings.tsx';
import { useWidgetState } from 'components/management/customDashboard/CustomWidgetContext.tsx';
import { useSubAccountAssetFilters } from 'components/technical/UseSubAccountAssetFilters.tsx';

const createOpenSummaryPresetKey = (id: string) => `customWidget/summaryOpenPositions/${id}`;

export const openPositionWidgets: CustomWidgetDescription[] = [
  {
    name: 'Open positions summary',
    type: 'summaryOpenPositions',
    description: 'List of open positions',
    icon: () => <GridView />,
    viewComponent: ({ id }) => {
      const initialState = useWidgetState<PositionSummarySettingsState>(id);
      return <PositionSummary presetSettingsKey={createOpenSummaryPresetKey(id)} {...initialState} />;
    },
    settingsComponent: (props) => (
      <PositionSummarySettings {...props} presetKey={createOpenSummaryPresetKey(props.id)} />
    ),
    initialH: 4,
    initialW: 3,
  },
  {
    name: 'Open positions summary light',
    type: 'summaryOpenPositionsLight',
    description: 'List of open positions',
    icon: () => <GridView />,
    viewComponent: ({ id }) => {
      const initialState = useWidgetState<PositionSummaryLightSettingsState>(id);
      const subAccountAssetFilters = useSubAccountAssetFilters(initialState);

      const { data } = useDefaultErrorHandling(
        usePortfolioDashboardInputQuery({
          variables: { subAccountAssetFilters, tilesSettings: UserSettings.TilesDateRange },
        })
      );

      if (!data) {
        return <Loader />;
      }

      return <PositionSummaryLight portfolio={data.portfolio} fullHeight />;
    },
    settingsComponent: PositionSummaryLightSettings,
    initialH: 4,
    initialW: 3,
  },
];
